<h2 mat-dialog-title>Advanced search</h2>

<mat-dialog-content>
  <form id="form" (submit)="submit($event)">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Filename/title</mat-label>
        <input matInput type="text" [formField]="filterForm.search" />
      </mat-form-field>
    </p>

    <p style="display: flex; gap: 1em">
      <mat-form-field appearance="outline">
        <mat-label>Sort by</mat-label>
        <mat-select [formField]="filterForm.sort">
          <mat-option value="created">Created</mat-option>
          <mat-option value="modified">Modified</mat-option>
          <mat-option value="title">Title/filename</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" style="flex-basis: 40%">
        <mat-label>Order</mat-label>
        <mat-select [formField]="filterForm.order">
          <mat-option value="asc">Ascending</mat-option>
          <mat-option value="desc">Descending</mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="fromPicker" [formField]="filterForm.from" />
        <mat-hint>YYYY-MM-DD</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Until</mat-label>
        <input matInput [matDatepicker]="untilPicker" [formField]="filterForm.until" />
        <mat-hint>YYYY-MM-DD</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="untilPicker"></mat-datepicker-toggle>
        <mat-datepicker #untilPicker></mat-datepicker>
      </mat-form-field>
    </p>

    <p>
      <mat-slide-toggle [formField]="filterForm.disablePrefix"
        >Search all directories</mat-slide-toggle
      >
    </p>
    @if (!filterForm.disablePrefix().value()) {
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Prefix</mat-label>
          <input matInput type="text" [formField]="filterForm.prefix" />

          @if (filterForm.prefix().errors().length) {
            <mat-error>{{ filterForm.prefix().errors()[0].message }}</mat-error>
          }
        </mat-form-field>
      </p>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="submit" form="form">Search</button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
